/**
 * Which published Stammdatei a billing release was ingested from.
 *
 * - `hpnr` — Bundeseinheitliches Heilmittelpositionsnummernverzeichnis, the
 *   value set behind § 302 Anlage 3 § 8.2.1 and the only published check on the
 *   output of the X-substitution. Published by the GKV-Spitzenverband.
 *
 * Mirrors `CatalogReleaseKind` in prescription-validation: same insert-only
 * release shape (ADR-0026), separate vocabulary because the two contexts must
 * not import each other.
 */
export var StammdatenReleaseKind;
(function (StammdatenReleaseKind) {
    StammdatenReleaseKind["HPNR"] = "hpnr";
})(StammdatenReleaseKind || (StammdatenReleaseKind = {}));
//# sourceMappingURL=stammdaten-release-kind.enum.js.map